import { FC } from 'react'
import Button from '../forms/Button'
import classNames from 'classnames'
import { TPlanSummary } from 'common/cms-types'
import { planPrice } from 'common/utils/planPrice'

type WhatsappPriceType = {
  onBuyNow: () => void
  className?: string
  planSummary: TPlanSummary
  actionButtonClassName?: string
}

const WhatsAppPrice: FC<WhatsappPriceType> = ({
  onBuyNow,
  className,
  planSummary,
  actionButtonClassName,
}) => {
  const monthlyPrice = planPrice.monthly[planSummary.slug]

  return (
    <div className={className}>
      <div className='d-flex flex-column'>
        <s className='text-danger fs-16'>£5.99/month</s>

        <span className='fs-28 fw-bold lh-105'>
          {monthlyPrice} <span className='fs-20'>/month</span>
        </span>
      </div>
      <Button className={classNames('mt-3 w-100 w-lg-auto', actionButtonClassName)} onClick={onBuyNow}>
        Buy Now
      </Button>
    </div>
  )
}

export default WhatsAppPrice
